import { makeAutoObservable } from 'mobx';
import { TagCondition, createTagCondition } from './TagCondition';
import { Media, createMedia } from '../../Media/Media';

export type ConditionalMedia = Media & {
  tagConditions: TagCondition[];
  readonly tagString: string;
  matches(tags?: string[]): boolean;
  matchCount(tags?: string[]): number;
};

export function createConditionalMedia(json?: Partial<ConditionalMedia>): ConditionalMedia {
  const base = createMedia(json);
  return makeAutoObservable({
    ...base,
    tagConditions: (json?.tagConditions || []).map((t: any) => createTagCondition(t)),

    get tagString(): string {
      return this.tagConditions.map((t) => t.tagString).join(' | ');
    },

    matches(tags: string[] = []): boolean {
      return this.tagConditions.length === 0 || this.tagConditions.some((t) => t.matches(tags));
    },

    matchCount(tags: string[] = []): number {
      return this.tagConditions.reduce((agg, t) => Math.max(agg, t.matchCount(tags)), 0);
    },
  });
}
